import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const getNumberFromString = (inputString) => {
  const [numericString, remain] = inputString.split("_");
  let string = "";
  let number = Number(numericString);
  // for number with ,
  if (numericString.includes(",")) {
    string = `${numericString.split(",")[0]},`;
    number = numericString.split(",")[1];
  } else if (numericString.includes(".")) {
    string = `${numericString.split(".")[0]}.`;
    number = numericString.split(".")[1];
  }
  return { string, number, remain };
};

function Counter({ end, duration }) {
  const parsed = typeof end === "string" ? getNumberFromString(end) : null;
  const isStatic = parsed !== null && parsed.number === null;
  const endNumber = isStatic ? 0 : (parsed?.number ?? end);
  const startString = parsed?.string ?? "";
  const addedString = parsed?.remain ?? "";
  const initialCount = endNumber > 100 ? endNumber - 100 : 0;

  const [count, setCount] = useState(initialCount);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (isStatic || !active || count >= endNumber) return;
    const timer = setTimeout(() => {
      setCount((prev) => prev + 1);
    }, duration);
    return () => clearTimeout(timer);
  }, [count, endNumber, duration, active, isStatic]);

  if (isStatic) {
    return (
      <motion.div className="about-green-number">
        <span>{parsed.string}</span>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="about-green-number"
      onViewportEnter={() => setActive(true)}
    >
      {startString && <span>{startString}</span>}
      <span>{count}</span>
      {addedString && <span>{addedString}</span>}
    </motion.div>
  );
}

export default Counter;
